// import React, { useContext } from 'react';
import React, { useState, useContext } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Card from '../components/common/Card';
import Label from '../components/common/Label';
import FormInput from '../components/FormInput';
import { Redirect } from 'react-router-dom';
import FormSuccess from '../components/FormSuccess';
// import FormError from '../components/FormError';
import GradientBar from '../components/common/GradientBar';
// import useIsMounted from '../components/common/useIsMounted';
import { AuthContext } from '../context/AuthContext';
import { FetchContext } from '../context/FetchContext';
import { useParams } from 'react-router-dom';
import GradientButton from '../components/common/GradientButton';
import logo from './../images/logo.png';

const LoginSchema = Yup.object().shape({
  password: Yup.string().required('password is required'),
  confirmPassword: Yup.string().required('Confirm Password is required'),
});
// const  LoginSchema: Yup.object().shape({
//     password: Yup.string().required('Password is required'),
//     confirmPassword: Yup.string().oneOf(
//       [Yup.ref('password'), null],
//       'Passwords must match'
//     ),
//   }),
// });

export const ResetPassword = (req, res, next) => {
  const authContext = useContext(AuthContext);
  const fetchContext = useContext(FetchContext);
  const [redirectOnLogin, setRedirectOnLogin] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState();
  // const [loginError, setLoginError] = useState();

  const { id } = useParams();

  const submitCredentials = async credentials => {
    try {
      console.log(`🦉 res creds: ${credentials}`);
      const { data } = await fetchContext.publicAxios.post(
        `reset-password`,
        credentials
      );

      setLoginSuccess(data.message);
      setTimeout(() => {
        setRedirectOnLogin(true);
      }, 700);
    } catch (error) {
      console.log(error);
      setLoginSuccess(null);
    }
  };

  return (
    <>
      {redirectOnLogin && <Redirect to="/login" />}
      <section className="w-full sm:w-1/2 h-screen m-auto p-8 sm:pt-10">
        <GradientBar />
        <Card>
          <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
              <div>
                <div className="w-32 m-auto mb-6">
                  <img src={logo} alt="Logo" />
                </div>
                <h2 className="mb-2 text-center text-3xl leading-9 font-extrabold text-gray-900">
                  Reset your password
                </h2>
              </div>

              <Formik
                initialValues={{
                  id: id,
                  password: '',
                  confirmPassword: '',
                }}
                onSubmit={values => submitCredentials(values)}
                validationSchema={LoginSchema}
              >
                {() => (
                  <Form className="mt-8">
                    {loginSuccess && <FormSuccess text={loginSuccess} />}
                    <div>
                      <div className="mb-1">
                        <Label text="Password" />
                      </div>
                      <FormInput
                        ariaLabel="Password"
                        name="password"
                        type="password"
                        placeholder="Password"
                      />
                      <div className="mb-1">
                        <Label text="Confirm Password" />
                      </div>
                      <FormInput
                        ariaLabel="Confirm Password"
                        name="confirmPassword"
                        type="password"
                        placeholder="Confirm Password"
                      />
                    </div>

                    <div className="mt-6">
                      <GradientButton type="submit" text="Submit" />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </section>
    </>
  );
};
